import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class UrlCleanupService {

	/**
	 * Cleans GTM and other tracking parameters from the URL hash
	 * Converts malformed URLs like #/plans&_gl=xxx to proper format #/plans?_gl=xxx
	 * and optionally removes specified tracking parameters
	 */
	cleanUrl(): void {
		if (typeof window === 'undefined' || !window.location.hash) {
			return;
		}

		let hash = window.location.hash;
		let modified = false;

		// Handle case where hash starts directly with tracking parameters (no route)
		// e.g., #_gl=xxx should be #/?_gl=xxx
		const trackingParams = ['_gl=', 'gclid=', 'fbclid=', '_ga=', 'mc_cid=', 'mc_eid='];
		const startsWithTrackingParam = trackingParams.some(param => hash.startsWith('#' + param));
		if (startsWithTrackingParam) {
			hash = '#/?' + hash.substring(1);
			modified = true;
		}

		// Fix malformed URLs where & is used instead of ? for the first parameter
		// e.g., #/plans&_gl=xxx should be #/plans?_gl=xxx
		const hashParts = hash.split('&');
		if (hashParts.length > 1 && !hashParts[0].includes('?')) {
			// First part is the route, rest are parameters
			const route = hashParts[0];
			const params = hashParts.slice(1);
			hash = route + '?' + params.join('&');
			modified = true;
		}

		// Parse the URL to extract route and query parameters
		const [routePart, queryPart] = hash.split('?');
		
		if (queryPart) {
			const urlParams = new URLSearchParams(queryPart);
			
			// List of tracking parameters to remove
			const trackingParams = ['_gl', '_ga', 'gclid', 'fbclid', 'mc_cid', 'mc_eid'];
			
			// Remove tracking parameters
			let hasTrackingParams = false;
			trackingParams.forEach(param => {
				if (urlParams.has(param)) {
					urlParams.delete(param);
					hasTrackingParams = true;
				}
			});

			if (hasTrackingParams) {
				modified = true;
			}

			// Reconstruct the hash
			const cleanQueryString = urlParams.toString();
			hash = routePart + (cleanQueryString ? '?' + cleanQueryString : '');
			
			// Normalize empty paths to root route
			if (hash === '#' || hash.startsWith('#?') || hash === '#/') {
				hash = '#/';
			}
		}

		// Update the URL if it was modified
		if (modified) {
			// Final normalization: ensure empty paths become root route
			if (hash === '#' || hash.startsWith('#?')) {
				hash = '#/';
			}
			
			// Use replaceState to avoid adding to browser history
			const newUrl = window.location.pathname + window.location.search + hash;
			window.history.replaceState(null, '', newUrl);
		}
	}

	/**
	 * Initialize URL cleanup - should be called early in app lifecycle
	 */
	initialize(): void {
		this.cleanUrl();
	}
}
